import React, { useState, useEffect } from "react";
import Header from "../Common_Files/Header";
import Footer from "../Common_Files/Footer";
import config from '../Common_Files/Config';
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import $ from "jquery";
import "datatables.net-bs5";
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import { format } from 'date-fns';

const OrderHistory = () => {
  const [reportrange, setReportrange] = useState('');
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const [orderHistory, setOrderHistory] = useState([]);
  const [draw, setDraw] = useState(1);
  const [start, setStart] = useState(0);
  const [length, setLength] = useState(50);
  const accessToken = localStorage.getItem('accessToken');

  const handleSubmit = (e) => {
    e.preventDefault();
    fetchData();
  };

  const handleDateChange = (dates) => {
    if (dates && dates.length === 2) {
      const [start, end] = dates;
      setFromDate(format(start, 'yyyy-MM-dd'));
      setToDate(format(end, 'yyyy-MM-dd'));
      setReportrange(`${format(start, 'MM/dd/yyyy')} - ${format(end, 'MM/dd/yyyy')}`);
    } else if (!dates) {
      // Handle clearing the dates
      setFromDate('');
      setToDate('');
      setReportrange('');
    }
  };

  const fetchData = async () => {
    const formData = new FormData();
    formData.append("searchByFromdate", fromDate);
    formData.append("searchByTodate", toDate);
    formData.append("role", selectedRole);
    formData.append('draw', draw);
    formData.append('start', start);
    formData.append('length', length);

    const apiUrl = `${config.api_url}/ws-delete-order`;
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to fetch sales data");
      }

      const data = await response.json();
      setOrderHistory(data.data);
      // Assuming you need to update some elements with totals
      $("#total_grand_total").text(data.total_grand_total);
      $("#total_grand_total1").text(data.total_grand_total1);
    } catch (error) {
      console.error("Error fetching sales data:", error);
    }
  };

  useEffect(() => {
    if (!accessToken) {
      window.location.href = '/login';
      return;
    }
    fetchData();
  }, [fromDate, toDate, selectedRole]);

  useEffect(() => {
    const table = $("#neworderTable").DataTable({
      data: orderHistory,
      columns: [
        {
          data: "order_date",
          title: "Order Date",
          render: (data, type, row) => {
            if (data) {
              // Normalize dd-mm-yy to dd-mm-yyyy
              const str = String(data).trim();
              const ddmmyy = /^(\d{2})-(\d{2})-(\d{2})$/;
              const match = str.match(ddmmyy);
              if (match) {
                const dd = match[1];
                const mm = match[2];
                const yy = parseInt(match[3], 10);
                const fullYear = yy <= 69 ? 2000 + yy : 1900 + yy;
                return `${dd}-${mm}-${fullYear}`;
              }

              // Fallback: try native parsing and format dd-mm-yyyy
              const date = new Date(str);
              if (!isNaN(date.getTime())) {
                const day = date.getDate().toString().padStart(2, '0');
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const year = date.getFullYear();
                return `${day}-${month}-${year}`;
              }
            }
            return data;
          }
        },
          {
          data: "deleted_date",
          title: "deleted Date",
          render: (data, type, row) => {
            if (data) {
              // Normalize dd-mm-yy to dd-mm-yyyy
              const str = String(data).trim();
              const ddmmyy = /^(\d{2})-(\d{2})-(\d{2})$/;
              const match = str.match(ddmmyy);
              if (match) {
                const dd = match[1];
                const mm = match[2];
                const yy = parseInt(match[3], 10);
                const fullYear = yy <= 69 ? 2000 + yy : 1900 + yy;
                return `${dd}-${mm}-${fullYear}`;
              }

              // Fallback: try native parsing and format dd-mm-yyyy
              const date = new Date(str);
              if (!isNaN(date.getTime())) {
                const day = date.getDate().toString().padStart(2, '0');
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const year = date.getFullYear();
                return `${day}-${month}-${year}`;
              }
            }
            return data;
          }
        },
        {
          data: 'reference_no',
          title: 'Order Id',

        },
        {
          data: "company_name",
          title: "Customers",
          render: data => `<p class="cut-text">${data}</p>`
        },
        { data: "order_amount", title: "Order Amount" }
      
      ],
      pageLength: 50,
      paging: true,
      lengthMenu: [10, 20, 50],
      searching: true,
      ordering: false,
      info: true,
      responsive: true,
      autoWidth: false,
      language: {
        paginate: {
          first: "First",
          last: "Last",
          next: "Next",
          previous: "Previous",
        },
        search: "Search:",
      },
    });

    return () => {
      table.destroy();
    };
  }, [orderHistory]);

  return (
    <div>
      <Header />
      <div className="breadcrumbs">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <a href="#">
                <i className="fa fa-home"></i>
              </a>{" "}
              &gt; <a href="/Dashboard">Dashboard</a> &gt;{" "}
              <span className="last-crumb">Delete Order</span>
            </div>
          </div>
        </div>
      </div>
      <div className="main-container">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="show-order-area dashboard">
                <div className="dashform">
                  <div className="topsearch-area">
                    <div className="row">
                      <div className="col-6">

                        <div className="row" style={{ marginRight: "10px" }}>
                          <label for="inputText" class="col-sm-2 col-form-label">Date Range
                          </label>
                          <div className="col-sm-7">
                            <DateRangePicker
                              value={[fromDate ? new Date(fromDate) : undefined, toDate ? new Date(toDate) : undefined]}
                              onChange={handleDateChange}
                              format="dd/MM/yyyy"
                              editable={false}
                              placeholder="DD/MM/YYYY - DD/MM/YYYY"
                              className="mr-2"
                              cleanable={true}
                              size="md"
                              style={{ width: '100%' }}
                              onClean={() => {
                                setFromDate('');
                                setToDate('');
                                setReportrange('');
                              }}
                            />
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
                <div className="verical-scrl-wrapper delete-order" id="style-3">
                  <table
                    className="table table-bordered dataTable"
                    id="neworderTable"
                  >
                    <thead>
                      <tr>
                        <th>Order Date</th>
                        <th>Deleted Date</th>
                        <th>Order Id</th>
                        <th>Customers</th>
                        <th>Order Amount</th>                      
                      </tr>
                    </thead>
                    <tbody>
                      {/* Data is populated by DataTables */}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default OrderHistory;
